import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

/**
 * Resolves the `eventWeek` key (`YYYY-<isoWeek>`) used to bucket tracked nutrition days.
 * Mirrors the logic in the `client_nutrition_day.eventWeek` column so the client and
 * the DB agree on which days belong to a given week.
 *
 * Used both for fetching (DB filter) and for the request-ordering guard in the reducer,
 * so it must be the single source of truth — keep it in sync with the backend.
 */
export const getNutritionEventWeek = (date: string): string => {
  const selectedDay = dayjs(date);
  const lastMonthIndex = 11;

  if (selectedDay.get("month") === lastMonthIndex && selectedDay.isoWeek() === 1) {
    // End-of-year edge case: the last days of December can belong to ISO week 1 of the next year.
    return `${selectedDay.add(1, "year").format("YYYY")}-${selectedDay.isoWeek()}`;
  }

  return `${selectedDay.format("YYYY")}-${selectedDay.isoWeek()}`;
};
